import { SymbolType } from 'data/Instrument/types'
import { TickerType } from 'data/types'

import * as AT from './actionTypes'

export type StopTickerActionType = {
  payload: { readonly symbol: SymbolType }
  type: typeof AT.STOP
}

export type TickerActionType =
  | {
      payload: { readonly symbol: SymbolType }
      type: typeof AT.RESET
    }
  | {
      payload: { readonly symbol: SymbolType }
      type: typeof AT.SET_SUBSCRIBED
    }
  | {
      payload: { readonly symbol: SymbolType; readonly ticker: TickerType }
      type: typeof AT.SET_UPDATE
    }
  | {
      type: typeof AT.SNAPSHOT
    }
  | StopTickerActionType

const reset = (symbol: SymbolType): TickerActionType => ({
  payload: { symbol },
  type: AT.RESET
})

const setSubscribed = (symbol: SymbolType): TickerActionType => ({
  payload: { symbol },
  type: AT.SET_SUBSCRIBED
})

const setUpdate = (symbol: SymbolType, ticker: TickerType): TickerActionType => ({
  payload: { symbol, ticker },
  type: AT.SET_UPDATE
})

const stop = (symbol: SymbolType): TickerActionType => ({
  payload: { symbol },
  type: AT.STOP
})

const snapshot = (): TickerActionType => ({
  type: AT.SNAPSHOT
})

export default {
  reset,
  setSubscribed,
  setUpdate,
  snapshot,
  stop
}
